import React,{useState,useEffect,useRef} from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Paper from '@mui/material/Paper';
import {Grid,Typography,Button,Link} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import {makeStyles} from '@mui/styles';
import Grow from '@mui/material/Grow';
import Slide from '@mui/material/Slide';
import Zoom from '@mui/material/Zoom';
import './NavBar.css'
import Collapse from '@mui/material/Collapse';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// import logo from '../../public/images/Logo.gif'
import Drawer from '@mui/material/Drawer';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';


const useStyles = makeStyles((theme)=>({
    MuiDrawer: {
        backgroundColor:'#112240'
      },
    typo:{
        color:'#ccd6f6',
        fontFamily:"Calibre,Inter,San Francisco,SF Pro Text",
        '&:hover':{
            color:'#64ffda',
            cursor:"pointer"
        },
        fontSize:'0.8rem'

    },
    number:{
        color:'#64ffda',
        
        fontSize:'0.9rem'
    },
    drawer:{
        display:'flex'

    },
    drawerItemTypo:{
        '&:hover':{
            color:'#64ffda'
        },
    drawerItem:{
        
        border:'1px solid black',

    },paper:{
        backgroundColor:'#112240'
    }

    }
}))


const NavBar = ({introRef,aboutRef,workRef,projectRef,getInTouchRef}) => {
    const classes = useStyles()
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)
    const [openDrawer,setOpenDrawer] = useState(false)
    const drawer = useRef(null)

   
    const resumeLink = "https://firebasestorage.googleapis.com/v0/b/suprith-hattikal.appspot.com/o/Suprith--Hattikal-FlowCV-Resume-20241230.pdf?alt=media&token=78702cab-a329-4785-a0c8-82e42974eecf"

  
    useEffect(() => {
      function handleResize() {
        setWindowWidth(window.innerWidth)
      }
  
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])

    function handleClose(){
        setOpenDrawer(false)
    }



    



    return (
        <div >
            
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="sticky" style={{backgroundColor:'#FFFFFF00',height:'80px'}} >
                    <Toolbar>

                    <Grid sx={{display:'flex',flex:1}}>
                        <IconButton onClick={()=>{introRef.current.scrollIntoView()}}>
                            <img
                                src={"./images/finalLogo.gif"}
                                style={{width:windowWidth>800?'50px':'30px',height:windowWidth>800?'50px':'30px'}}
                                alt="Suprith Hattikal Logo"
                            />
                        </IconButton>

                        {windowWidth<800?<IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2,position:'absolute',right:'5px' }}
                            onClick={()=>{setOpenDrawer(true)}}
                        >
                            <MenuIcon style={{color:'#64ffda'}}/>
                        </IconButton>:null}

                        {windowWidth>800?
                        <Grid container flexDirection={'row'} sx={{display:'flex',alignSelf:'flex-end',justifyContent:'flex-end'}}>
                            <IconButton onClick={()=>{aboutRef.current.scrollIntoView()}} sx={{"&:hover":{color:"#64ffda"},margin:'0px 10px 0px 10px'}}>
                                <Typography className={classes.number}  style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>01.</Typography>
                                <Typography className={classes.typo}   style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>About</Typography>
                            </IconButton>
                            <IconButton onClick={()=>{workRef.current.scrollIntoView()}} sx={{"&:hover":{color:"#64ffda"},margin:'0px 10px 0px 10px'}}>
                                <Typography className={classes.number} style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}} >02. </Typography>
                                <Typography className={classes.typo}  style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}} >Experience</Typography>
                            </IconButton>
                            <IconButton onClick={()=>{projectRef.current.scrollIntoView()}} sx={{"&:hover":{color:"#64ffda"},margin:'0px 10px 0px 10px'}}>
                                <Typography className={classes.number}  style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>03. </Typography>
                                <Typography className={classes.typo}   style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Work</Typography>
                            </IconButton>
                            <IconButton onClick={()=>{getInTouchRef.current.scrollIntoView()}} sx={{"&:hover":{color:"#64ffda"},margin:'0px 10px 0px 10px'}}>
                                <Typography className={classes.number}  style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>04. </Typography>
                                <Typography className={classes.typo}   style={{fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Contact</Typography>
                            </IconButton>
                            <IconButton sx={{"&:hover":{color:"#64ffda"},border:'1px solid #64ffda',borderRadius:'5px',padding:"0px 20px 0px 20px",margin:'0px 10px 0px 10px'}}>
                                <Link style={{textDecoration:'none'}} href={resumeLink} target="_blank">
                                    <Typography className="menuItem1" variant="h6" color="initial"  style={{color:'#64ffda',fontSize:'0.8rem','&:hover':{color:"#64ffda",background:"#64ffda"},fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Resume</Typography>
                                </Link>
                            </IconButton>

                        </Grid>:
                        <SwipeableDrawer
                            open={openDrawer}
                            onOpen={()=>{setOpenDrawer(true)}}
                            onClose={handleClose}
                            anchor={"right"}
                            className={classes.drawer}
                            variant="temporary"
                            ref={drawer}
                            disableRestoreFocus
                         
                            classes={{paper: classes.paper}}
                            PaperProps={{
                                sx: {
                                    backgroundColor: '#112240',
                                    
                                }
                            }}
                            
                        >
                            <Button onClick={()=>{aboutRef.current.scrollIntoView();handleClose()}} style={{width:'200px',justifyContent:'flex-start',margin:'10px 0px 10px'}}>
                                <Typography  variant="h6" color="initial"  style={{color:'#64ffda',fontSize:'0.8rem',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text","&:hover":{color:"#64ffda",background:'#64ffda'}}}>01.</Typography>
                                <Typography  variant="h6" color="initial"  style={{color:'#ccd6f6',fontSize:'0.8rem','&:hover':{color:"#64ffda",background:"#64ffda"},fontFamily:"Calibre,Inter,San Francisco,SF Pro Text","&:hover":{color:"#64ffda",background:'#64ffda'}}}>About</Typography>
                            </Button>
                            <Button onClick={()=>{workRef.current.scrollIntoView();handleClose()}} style={{width:'200px',justifyContent:'flex-start',margin:'10px 0px 10px'}}>
                                <Typography className="menuItem" variant="h6" color="initial"  style={{color:'#64ffda',fontSize:'0.8rem',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>02.</Typography>
                                <Typography className="menuItem1" variant="h6" color="initial"  style={{color:'#ccd6f6',fontSize:'0.8rem','&:hover':{color:"#64ffda",background:"#64ffda"},fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Experience</Typography>
                            </Button>
                            <Button onClick={()=>{projectRef.current.scrollIntoView();handleClose()}} style={{width:'200px',justifyContent:'flex-start',margin:'10px 0px 10px'}}>
                                <Typography className="menuItem" variant="h6" color="initial"  style={{color:'#64ffda',fontSize:'0.8rem',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>03.</Typography>
                                <Typography className="menuItem1" variant="h6" color="initial"  style={{color:'#ccd6f6',fontSize:'0.8rem','&:hover':{color:"#64ffda",background:"#64ffda"},fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Work</Typography>
                            </Button>
                            <Button  onClick={()=>{getInTouchRef.current.scrollIntoView();handleClose()}} style={{width:'200px',justifyContent:'flex-start',margin:'10px 0px 10px'}}>
                                <Typography className="menuItem" variant="h6" color="initial"  style={{color:'#64ffda',fontSize:'0.8rem',fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>04.</Typography>
                                <Typography className="menuItem1" variant="h6" color="initial"  style={{color:'#ccd6f6',fontSize:'0.8rem','&:hover':{color:"#64ffda",background:"#64ffda"},fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Contact</Typography>
                            </Button>
                            <Button onClick={()=>{handleClose()}} sx={{border:'1px solid #64ffda',borderRadius:'5px',padding:"5px 20px 5px 20px",margin:'0px 10px 0px 10px'}}>
                                <Link style={{textDecoration:'none'}} href={resumeLink} target="_blank">
                                    <Typography className="menuItem1" variant="h6" color="initial"  style={{color:'#64ffda',fontSize:'0.8rem','&:hover':{color:"#64ffda",background:"#64ffda"},fontFamily:"Calibre,Inter,San Francisco,SF Pro Text"}}>Resume</Typography>
                                </Link>
                               
                            </Button>

                        </SwipeableDrawer>
                        }
                        
                    </Grid>
                    </Toolbar>
                </AppBar>
            </Box> 
            
        </div>
    )
}

export default NavBar
